export default function getInstanceFileKey(options: {
  storageProvider: string;
  prefix: string;
  shortid: string;
  studyUID: string;
  seriesUID: string;
  instanceUID: string;
  filename?: string;
}) {
  const {
    storageProvider,
    prefix,
    shortid,
    filename,
    studyUID,
    seriesUID,
    instanceUID,
  } = options;
  let url: string;
  if (storageProvider === "litevna") {
    url = `studies/${studyUID}/series/${seriesUID}/instances/${instanceUID}`;
  } else {
    if (!filename) {
      throw new Error("No filename provided");
    }
    url = `${prefix}/${shortid}_${seriesUID}/${filename}`;
  }

  if (prefix) {
    return `${prefix}/${url}`;
  }

  return url;
}
